import vuexPersist from "@/store/vuex-persist";
import Vue from "vue";
import Vuex from "vuex";

import account from "./account";
import app from "./app";
import appConfig from "./app-config";
import auth from "./auth";
import createAccount from "./create-account";
import dashboard from "./dashboard";
import user from "./user";
import verticalMenu from "./vertical-menu";
import sport from "./sport";
import promotions from "./promotions";
import settings from "./settings";
import trading from "./trading";
import segment from "./segment";
import finance from "./finance";
import bettingConfig from "./betting-config";
import marketing from "./marketing";
import bdm from "./bdm";
import reporting from "./reporting";  

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    auth,
    account,
    createAccount,
    user,
    dashboard,
    appConfig,
    verticalMenu,
    sport,
    promotions,
    settings,
    trading,
    segment,
    finance,
    bettingConfig,
    marketing,
    bdm,
    reporting
  },
  strict: process.env.DEV,
  plugins: [vuexPersist.plugin],
});
